import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appEditMenuHover]'
})
export class EditMenuHoverDirective {

  constructor(private el: ElementRef) { }
  @HostListener('mouseenter') onMouseEnter() {
    this.highlight('#e8f6ff');
  }
  @HostListener('mouseleave') onMouseLeave() {
    this.highlight(null);
  }
  private highlight(color: string) {
    this.el.nativeElement.style.backgroundColor = color;
  }

}
